import { PageLoaderError } from './PageLoaderError';

export class PageLoaderErrorRedirect extends PageLoaderError {
  constructor(readonly permenant: boolean, readonly destination: string) {
    super('Redirect');
  }
}
